/* ─────────────────────────────────────────────────────────────────────────────
   МАРКЕТПЛЕЙС — общие данные и мелкие помощники.

   Лоты приходят с клиента ровно теми же полями, что и у аукциона в телефоне
   (src_client/phone/auction.js): id, type, title, text, image, createPrice,
   lastPrice, createName, createUuid, time, betCount, betsList.
   Никаких новых каналов к серверу здесь не заводится — только удобная обёртка.
   ───────────────────────────────────────────────────────────────────────────── */
import { vehiclePhoto } from 'json/carPhotos'
import { GetTime } from 'api/moment'

/* индекс = поле type у лота, порядок менять НЕЛЬЗЯ: он совпадает с сервером */
export const CATS = [
    { id: 0, name: 'Недвижимость', hint: 'Дома и квартиры',      icon: 'home' },
    { id: 1, name: 'Бизнес',       hint: 'Готовые предприятия',  icon: 'biz'  },
    { id: 2, name: 'Транспорт',    hint: 'Личные автомобили',    icon: 'car'  },
];

export const catName = (type) => (CATS[type] ? CATS[type].name : 'Прочее');
export const catIcon = (type) => (CATS[type] ? CATS[type].icon : 'home');

/* фото есть только у транспорта — берём из нашей фотобазы (json/carPhotos) */
export const lotPhoto = (item) => {
    if (!item || item.type !== 2 || !item.image) return '';
    try { return vehiclePhoto (String (item.image).toLowerCase ()); }
    catch (e) { return ''; }
};

/* «Sam_Rodriguez» из стора и «Sam Rodriguez» из списка ставок — один человек */
export const sameName = (a, b) =>
    String (a || '').replace (/_/g, ' ').trim ().toLowerCase () ===
    String (b || '').replace (/_/g, ' ').trim ().toLowerCase ();

export const niceName = (name) => String (name || '').replace (/_/g, ' ');

/* сколько осталось до конца торгов. Время сервера берём через GetTime,
   чтобы часы совпадали с теми, что показывает игра. */
export const leftInfo = (time) => {
    try {
        let mins = GetTime (time).diff (GetTime (), 'minutes');
        if (isNaN (mins)) return { text: '—', soon: false, over: false };
        if (mins <= 0) return { text: 'завершается', soon: true, over: true };

        const days = Math.floor (mins / 1440); mins -= days * 1440;
        const hours = Math.floor (mins / 60);  mins -= hours * 60;

        let text;
        if (days > 0) text = days + ' д ' + hours + ' ч';
        else if (hours > 0) text = hours + ' ч ' + mins + ' мин';
        else text = mins + ' мин';

        return { text, soon: days === 0 && hours < 1, over: false };
    } catch (e) {
        return { text: '—', soon: false, over: false };
    }
};

/* положение игрока в торгах: свой лот / лидирует / ставку перебили */
export const myState = (item, uuid, name) => {
    if (!item) return '';
    if (item.createUuid === uuid) return 'own';

    const bets = item.betsList || [];
    if (!bets.length) return '';

    const last = bets[bets.length - 1];
    if (sameName (last && last.name, name)) return 'lead';
    if (bets.some ((b) => sameName (b.name, name))) return 'outbid';
    return '';
};

/* «1 участник / 2 участника / 5 участников» */
export const betWord = (n) => {
    const num = Number (n) || 0;
    const t = num % 100 > 10 && num % 100 < 20 ? 0 : num % 10;
    if (t === 1) return 'участник';
    if (t >= 2 && t <= 4) return 'участника';
    return 'участников';
};

export const SORTS = [
    { id: 'time',  name: 'Скоро закончатся' },
    { id: 'cheap', name: 'Сначала дешёвые'  },
    { id: 'rich',  name: 'Сначала дорогие'  },
    { id: 'new',   name: 'Новые лоты'       },
];

export const sortLots = (list, mode) => {
    const arr = [...list];
    if (mode === 'cheap') return arr.sort ((a, b) => (a.lastPrice || 0) - (b.lastPrice || 0));
    if (mode === 'rich')  return arr.sort ((a, b) => (b.lastPrice || 0) - (a.lastPrice || 0));
    if (mode === 'new')   return arr.sort ((a, b) => (b.id || 0) - (a.id || 0));
    // по умолчанию — те, что закончатся раньше всех
    return arr.sort ((a, b) => String (a.time || '').localeCompare (String (b.time || '')));
};

export const matchSearch = (item, query) => {
    const q = String (query || '').trim ().toLowerCase ();
    if (!q) return true;
    if (q[0] === '№' || q[0] === '#') return String (item.id) === q.slice (1).trim ();
    return [item.title, item.text, item.createName, catName (item.type), '№' + item.id]
        .some ((v) => String (v || '').toLowerCase ().includes (q));
};
